import React from 'react';
import ReactJoyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { QARFormStore } from 'src/stores/qarFormStore';

export class IntroJoy extends React.Component<{
    store: QARFormStore;
}> { 

    constructor(props: any) {
        super(props);
        this.state={
        run: false,
        steps: [
            {
                disableBeacon: true,
                target: ".header",
                content:
                    (
                        <span><b>Welcome</b> to your Quarterly Access Review dashboard! 👋
                        <br />
                        <br />
                        This walkthrough will help you process your reports swiftly and confidently.</span>
                    )
            },
            {
                disableBeacon: true, 
                target: ".quarter",
                content: "Select a review period."
            },
            {
                disableBeacon: true, 
                target: ".organization",
                content: "Overview of your direct reporting structure."
            },
            {
                disableBeacon: true, 
                target: ".myManagers",
                content: "Click a manager’s name to display a list of their team members."
            },
            {
                disableBeacon: true, 
                target: ".allDirectReports",
                content: "View details and role assignments for your direct reports."
            },
            {
                disableBeacon: true, 
                target: ".MuiToolbar-root",
                content: "Use search functionality and filter toggles."
            },
            {
                disableBeacon: true, 
                target: ".reportRole",
                content: "Click to review a user’s role groups."
            },
            {
                disableBeacon: true, 
                target: ".delegate",
                content: "Select a new manager for this employee review ."
            },
            {
                disableBeacon: true, 
                target: ".directReports",
                content: "Review the account access permissions of your direct reports."
            },
            {
                disableBeacon: true, 
                target: ".reportGroups",
                content: "Click to review user’s account permissions groups."
            },
            {
                disableBeacon: true, 
                target: ".accountActions",
                content: "Select the appropriate action for each direct report."
            },
            // {
            //     disableBeacon: true, 
            //     target: ".comment",
            //     content:
            //         (
            //             <span>If you choose the <b>Revoked</b> or <b>Change</b> options, include corresponding Jira ticket number as link.</span>
            //         )
            // },
            // {
            //     disableBeacon: true, 
            //     target: ".ticket",
            //     content:
            //     (
            //         <span>If you choose the <b>Revoked</b> or <b>Change</b> options, include corresponding Jira ticket number as link.</span>
            //     ) 
            // },
            {
                disableBeacon: true, 
                target: ".systemAccounts",
                content: "View details for system accounts assigned to you for review."
            },
            {
                disableBeacon: true, 
                target: ".deadline",
                content: "Remember!"
            },
            {
                disableBeacon: true, 
                target: ".resetForm",
                content: "Click to reset form."
            },
            {
                disableBeacon: true, 
                target: ".saveForm",
                content: "Save your changes."
            },
            {
                disableBeacon: true, 
                target: ".links",
                content: "Documentation and Slack resources."
            }
        ],
        stepIndex: 0, // a controlled tour
        }
    }

    handleClick = () => {
        
        // console.log("Intro begin.");
        
        this.props.store.walkthrough = true;

        this.setState({
            run: true
        });
    };
    
    handleJoyrideCallback = (data: { action: any; index: any; status: any; type: any; }) => {
        const { action, index, status, type } = data;

        // console.log(STATUS);
    
        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
          // Update state to advance the tour
          this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
        }
        else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
          // Need to set our running state to false, 
          // so we can restart if we click start again.
          this.setState({ run: false });
          this.setState({ stepIndex: 0 });          

          this.props.store.walkthrough = false;

        //   console.log("Intro end.");

        }
    
        // console.log(type);
        // console.log(data); //eslint-disable-line no-console
        // console.groupEnd();

    };

    render () {

        const { run, stepIndex, steps } = this.state;

        // console.log(run);
        // console.log(steps);
        // console.log(stepIndex);

        return (
            <>
            <ReactJoyride
                steps={steps}
                run={run}
                stepIndex={stepIndex}
                continuous = {true}
                scrollToFirstStep = {true}
                showProgress = {false}
                showSkipButton = {true}
                spotlightClicks = {true}
                disableCloseOnEsc = {true}
                disableOverlay = {false}
                disableOverlayClose = {false} 
                hideCloseButton = {true}
                hideBackButton = {false}
                locale={{
                    next: <span>Next</span>,
                    back: <span>Back</span>
                }}
                callback={this.handleJoyrideCallback}
                styles={{
                    options: {
                        arrowColor: '#fff',
                        backgroundColor: '#fff',
                        overlayColor: 'rgba(0, 0, 0, 0.6)',
                        primaryColor: '#303f9f',
                        textColor: 'rgba(0, 0, 0, 0.87)',
                        width: 320,
                        zIndex: 1010,
                    }
                }}
            />
            <button
                className='MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary how-to-button'
                onClick={this.handleClick}>
                    Walkthrough
            </button>
            </>
        );
      }
};